import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getCycles, getDashboard, getPrograms } from '../api/endpoints'
import { ErrorNotice } from '../components'
import HowItWorks from '../HowItWorks'
import CountUp from '../CountUp'
import { statusLabel } from '../lib/format'

export default function DashboardPage() {
  const [cycleId, setCycleId] = useState('')
  const [programId, setProgramId] = useState('')
  const cycles = useQuery({ queryKey: ['cycles'], queryFn: getCycles })
  const programs = useQuery({ queryKey: ['programs'], queryFn: getPrograms })
  const dash = useQuery({ queryKey: ['dashboard', cycleId, programId], queryFn: () => getDashboard({ cycleId, programId }), refetchInterval: 30_000 })

  return (
    <div>
      <h1>Dashboard</h1>
      <HowItWorks id="dashboard" title="How Compass works, start to finish" lead="Five steps from an empty system to a finished report." steps={[{ icon: 'campaigns', title: "Create a campaign", text: "Set the questions, dates and registration link." },{ icon: 'invites', title: "Bring people in", text: "Share the link, or upload a list to send invitations." },{ icon: 'applications', title: "Candidates take the tests", text: "They register, give consent, read the instructions and sit each test. Answers save as they go." },{ icon: 'results', title: "Scores appear", text: "Scoring starts the moment a test is submitted. Percentiles update on a schedule." },{ icon: 'download', title: "Review and share", text: "Open any applicant, read the report, download results and PDF reports." }]} />
      <div className="toolbar">
        <label>Cycle<select value={cycleId} onChange={(e) => setCycleId(e.target.value)}><option value="">All cycles</option>{cycles.data?.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></label>
        <label>Program<select value={programId} onChange={(e) => setProgramId(e.target.value)}><option value="">All programs</option>{programs.data?.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select></label>
      </div>
      <ErrorNotice error={dash.error} />
      {dash.data && (
        <>
          <div className="grid" role="list" aria-label="Totals">
            <div className="stat" role="listitem"><b><CountUp value={dash.data.invited} /></b><span>Invited</span></div>
            <div className="stat" role="listitem"><b><CountUp value={dash.data.consented} /></b><span>Consent given</span></div>
            {dash.data.assessments.map((a) => (
              <div key={a.versionId} className="stat" role="listitem"><b><CountUp value={a.started} /></b><span>{a.name}: started ({a.inProgress} in progress, {a.submitted} submitted, {a.autoSubmitted} auto-submitted)</span></div>
            ))}
          </div>
          <h2 style={{ marginTop: 20 }}>Applications by status</h2>
          <div className="table-wrap"><table>
            <thead><tr><th>Status</th><th className="num">Applications</th></tr></thead>
            <tbody>
              {Object.entries(dash.data.applicationsByStatus).map(([s, n]) => <tr key={s}><td>{statusLabel(s)}</td><td className="num">{n}</td></tr>)}
              {Object.keys(dash.data.applicationsByStatus).length === 0 && <tr><td colSpan={2} className="muted">Nothing yet. Invite candidates to get started.</td></tr>}
            </tbody>
          </table></div>
        </>
      )}
    </div>
  )
}
